"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggles = exports.FeatureToggleEndpointKeys = exports.FeatureToggleRemoteNames = exports.FeatureToggleLocalNames = void 0;
var FeatureToggleLocalNames;
(function (FeatureToggleLocalNames) {
    FeatureToggleLocalNames["AntiPiracy"] = "antiPiracy";
    FeatureToggleLocalNames["CampaignSparkle"] = "campaignSparkle";
    FeatureToggleLocalNames["DrippingBulkAction"] = "drippingBulkAction";
    FeatureToggleLocalNames["NewRelic"] = "newRelic";
    FeatureToggleLocalNames["PersonaConfig"] = "personaConfig";
    FeatureToggleLocalNames["PushNotifications"] = "pushNotifications";
    FeatureToggleLocalNames["SalesCampaignList"] = "salesCampaignList";
    FeatureToggleLocalNames["HtmlSanitizer"] = "htmlSanitizer";
    FeatureToggleLocalNames["ConfigDrm"] = "configDrm";
    FeatureToggleLocalNames["ReasonBlockModal"] = "reasonBlockModal";
    FeatureToggleLocalNames["ConfigDrmDeviceList"] = "configDrmDeviceList";
    FeatureToggleLocalNames["ContentListVirtualized"] = "contentListVirtualized";
    FeatureToggleLocalNames["MembershipBanner"] = "membershipBanner";
    FeatureToggleLocalNames["ContentImport"] = "contentImport";
    FeatureToggleLocalNames["DrippingByClass"] = "drippingByClass";
    FeatureToggleLocalNames["DrippingByQuiz"] = "drippingByQuiz";
    FeatureToggleLocalNames["BulkActionMenu"] = "bulkActionMenu";
    FeatureToggleLocalNames["CreateModuleConcept"] = "createModuleConcept";
    FeatureToggleLocalNames["CreateContentConcept"] = "createContentConcept";
})(FeatureToggleLocalNames || (exports.FeatureToggleLocalNames = FeatureToggleLocalNames = {}));
var FeatureToggleRemoteNames;
(function (FeatureToggleRemoteNames) {
    FeatureToggleRemoteNames["AddClassModules"] = "APP_CLUB_ADMIN_ADD_CLASS_MODULES";
    FeatureToggleRemoteNames["ContentStructureAI"] = "APP_CLUB_ADMIN_CONTENT_STRUCTURE_AI";
    FeatureToggleRemoteNames["LegacyRedirectAlert"] = "REDIRECT_TO_HOTMART_CLUB_ALERT";
    FeatureToggleRemoteNames["CtaCommunities"] = "ENABLED_CTA_COMMUNITY";
    FeatureToggleRemoteNames["CertificateQrCode"] = "CLUB_ADMIN_CERTIFICATE_QR_CODE";
    FeatureToggleRemoteNames["SurveyThirdyProducts"] = "ENABLE_SURVEY_THIRDY_PRODUCTS";
    FeatureToggleRemoteNames["AccountConsumer"] = "ACCOUNT_CONSUMER";
    FeatureToggleRemoteNames["ActivateFreeSignup"] = "ENABLE_ACTIVATE_FREE_SIGNUP";
    FeatureToggleRemoteNames["PromoteProductModal"] = "ENABLE_AUDIENCE_PROMOTE_PRODUCT_MODAL";
    FeatureToggleRemoteNames["EnableHotmartClubAdminCustomDomain"] = "ENABLE_HOTMART_CLUB_ADMIN_CUSTOM_DOMAIN";
    FeatureToggleRemoteNames["EnableNewClubTemplateExperiment"] = "ENABLE_NEW_CLUB_TEMPLATE_EXPERIMENT";
    FeatureToggleRemoteNames["EnableNewClubMigrationCTA"] = "ENABLE_NEW_CLUB_MIGRATION_CTA";
    FeatureToggleRemoteNames["EnableMentorshipExperiment"] = "ENABLE_MENTORSHIP_EXPERIMENT";
    FeatureToggleRemoteNames["ContentListConcept"] = "APP_CLUB_ADMIN_CONTENT_LIST_CONCEPT";
})(FeatureToggleRemoteNames || (exports.FeatureToggleRemoteNames = FeatureToggleRemoteNames = {}));
var FeatureToggleEndpointKeys;
(function (FeatureToggleEndpointKeys) {
    FeatureToggleEndpointKeys["GetToggleByUnleashId"] = "get.toggle.byUnleashId";
})(FeatureToggleEndpointKeys || (exports.FeatureToggleEndpointKeys = FeatureToggleEndpointKeys = {}));
exports.FeatureToggles = {
    ...FeatureToggleRemoteNames,
    ...FeatureToggleLocalNames
};
